/**
 * Web Style Import
 *
 */

import './dnb-test-element.scss'
